import { useEffect, useState } from 'react';

import { ModalHeader } from '@cfa/react-components';

import { cn } from '@/utils/tailwind';

import { ScrollModalProps } from './ScrollModalFooter';
export interface ScrollModalHeaderProps extends ScrollModalProps {
  className?: string;
}

const ScrollModalHeader: React.FC<ScrollModalHeaderProps> = ({
  scrollRef,
  children,
  className,
  ...props
}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const updateScrollStatus = () => {
      const scrollTop = scrollRef.current?.scrollTop;
      if (scrollTop !== 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    scrollRef.current?.addEventListener('scroll', updateScrollStatus);

    return () => window.removeEventListener('scroll', updateScrollStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollRef.current]);

  return (
    <ModalHeader
      className={cn(
        'z-5!',
        {
          'shadow-elevation-16!': isScrolled,
        },
        className,
      )}
      {...props}
    >
      {children}
    </ModalHeader>
  );
};

export default ScrollModalHeader;
